import { WidgetControlType } from '@examdojo/core/widget';

import type { QuadraticPreset } from './quadratic-preset.model';

export const ROOT_CALCULATION_PRESET: QuadraticPreset = {
  id: 'root-calculation',
  title: 'Root Calculation Mode',
  description: 'Focus on finding roots with direct input',
  config: {
    id: 'quadratic-root-calculation',
    type: 'quadratic-function',
    params: {
      a: 1,
      b: 0,
      c: -4,
    },
    display: {
      grid: false,
      axes: true,
      vertex: false,
      roots: { enabled: true, label: { show: true, format: 'coordinate' } },
      axisOfSymmetry: false,
      yIntercept: false,
      parabola: { strokeWidth: 3 },
    },
    behavior: {
      features: {
        sliders: false,
        interaction: false,
      },
      controls: [
        {
          id: 'input-a',
          type: WidgetControlType.MathInput,
          label: 'Coefficient a',
          param: 'a',
          position: 'canvas-overlay',
          defaultValue: 1,
          trigger: { action: 'UPDATE_COEFFICIENTS', payload: { param: 'a' } },
        },
        {
          id: 'input-b',
          type: WidgetControlType.MathInput,
          label: 'Coefficient b',
          param: 'b',
          position: 'canvas-overlay',
          defaultValue: 0,
          trigger: { action: 'UPDATE_COEFFICIENTS', payload: { param: 'b' } },
        },
        {
          id: 'input-c',
          type: WidgetControlType.MathInput,
          label: 'Coefficient c',
          param: 'c',
          position: 'canvas-overlay',
          defaultValue: -4,
          trigger: { action: 'UPDATE_COEFFICIENTS', payload: { param: 'c' } },
        },
      ],
    },
  },
};
